let elements = {
  blockCheck: true,
  mainImage: {
    imagePath: 'games/page013_game0/img/bcg.webp',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  audio: { click: 'games/page013_game0/audio/click.mp3' },
  pick: 3,
  progressBar: {
    cssStyle: {
      left: '840px',
      bottom: '0',
      width: '240px',
      height: '122px',
    },
    image: {
      0: 'games/page013_game0/img/0.png',
      1: 'games/page013_game0/img/1.png',
      2: 'games/page013_game0/img/2.png',
      3: 'games/page013_game0/img/3.png',
    },
  },
  items: [
    {
      id: 'i1',
      linkedId: 'i4',
      audioSrc: 'games/page013_game0/audio/19_sleepy.mp3',
      image: {
        pos: {
          x: 49,
          y: 362,
        },
        width: 270,
        height: 394,
        src: 'games/page013_game0/img/sleepy.png',
      },
      mask: {
        pos: {
          x: 39,
          y: 352,
        },
        width: 290,
        height: 414,
        src: 'games/page013_game0/img/sleepy_blue.png',
      },
    },
    {
      id: 'i2',
      linkedId: 'i5',
      audioSrc: 'games/page013_game0/audio/21_scared.mp3',
      image: {
        pos: {
          x: 326,
          y: 295,
        },
        width: 315,
        height: 458,
        src: 'games/page013_game0/img/scared.png',
      },
      mask: {
        pos: {
          x: 316,
          y: 285,
        },
        width: 335,
        height: 478,
        src: 'games/page013_game0/img/scared_green.png',
      },
    },
    {
      id: 'i3',
      linkedId: 'i6',
      audioSrc: 'games/page013_game0/audio/20_hungry.mp3',
      image: {
        pos: {
          x: 602,
          y: 287,
        },
        width: 327,
        height: 470,
        src: 'games/page013_game0/img/hungry.png',
      },
      mask: {
        pos: {
          x: 592,
          y: 277,
        },
        width: 347,
        height: 490,
        src: 'games/page013_game0/img/hungry_pink.png',
      },
    },
    {
      id: 'i4',
      linkedId: 'i1',
      audioSrc: 'games/page013_game0/audio/16_sad.mp3',
      image: {
        pos: {
          x: 993,
          y: 362,
        },
        width: 274,
        height: 394,
        src: 'games/page013_game0/img/sad.png',
      },
      mask: {
        pos: {
          x: 983,
          y: 352,
        },
        width: 294,
        height: 414,
        src: 'games/page013_game0/img/sad_blue.png',
      },
    },
    {
      id: 'i5',
      linkedId: 'i2',
      audioSrc: 'games/page013_game0/audio/18_angry.mp3',
      image: {
        pos: {
          x: 1249,
          y: 302,
        },
        width: 277,
        height: 452,
        src: 'games/page013_game0/img/angry.png',
      },
      mask: {
        pos: {
          x: 1239,
          y: 292,
        },
        width: 297,
        height: 472,
        src: 'games/page013_game0/img/angry_green.png',
      },
    },
    {
      id: 'i6',
      linkedId: 'i3',
      audioSrc: 'games/page013_game0/audio/15_happy.mp3',
      image: {
        pos: {
          x: 1512,
          y: 290,
        },
        width: 352,
        height: 465,
        src: 'games/page013_game0/img/happy.png',
      },
      mask: {
        pos: {
          x: 1512,
          y: 280,
        },
        width: 362,
        height: 485,
        src: 'games/page013_game0/img/happy_pink.png',
      },
    },
  ],
  mbStaticAudioItemData: [
    {
      src: 'games/page013_game0/audio/15_happy.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page013_game0/img/audioOn.png', iconOff: 'games/page013_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 860,
        x: 1735,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
    {
      src: 'games/page013_game0/audio/16_sad.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page013_game0/img/audioOn.png', iconOff: 'games/page013_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 860,
        x: 1130,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
    {
      src: 'games/page013_game0/audio/18_angry.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page013_game0/img/audioOn.png', iconOff: 'games/page013_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 860,
        x: 1390,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
    {
      src: 'games/page013_game0/audio/19_sleepy.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page013_game0/img/audioOn.png', iconOff: 'games/page013_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 860,
        x: 180,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
    {
      src: 'games/page013_game0/audio/20_hungry.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page013_game0/img/audioOn.png', iconOff: 'games/page013_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 860,
        x: 775,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
    {
      src: 'games/page013_game0/audio/21_scared.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page013_game0/img/audioOn.png', iconOff: 'games/page013_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 860,
        x: 510,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
  ],
};

export default elements;
